import React from 'react';
import { useChatbotStore } from '../../store/chatbot.store';
import './chatbot.scss';

const ChatbotButton: React.FC = () => {
  const { isOpen, toggleChat } = useChatbotStore();
  
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault(); // Prevent form submission/page reload
    toggleChat();
  };

  return (
    <button 
      type="button"
      className={`chatbot-toggle-button ${isOpen ? 'open' : ''}`}
      onClick={handleClick}
      aria-label={isOpen ? "Close chat assistant" : "Open chat assistant"}
    >
      {isOpen ? (
        <i className="tim-icons icon-simple-remove"></i>
      ) : (
        <i className="tim-icons icon-chat-33"></i>
      )}
    </button>
  );
};

export default ChatbotButton;